<template>
  <div>
    <div class="quick-flex-col quick-items-start section_2 space-y-68">
      <span class="text_9">快速运车</span>
      <span class="text_10">运输干线网络辐射全国，承运线路2000+。</span>
    </div>
    <div class="nav">
      <div
        class="nav-box"
        :style="{
          color: navActive == item.id ? '#3c9cff' : 'rgba(56, 56, 56, 1)',
        }"
        v-for="item in tableData"
        :key="item.id"
      >
        <a :href="getId(item.id)">
          {{ item.name }}
        </a>
      </div>
    </div>
    <div class="quick-flex-col page">
      <div class="quick-flex-col quick-items-start group_4 space-y-36" style="">
        <div class="group_5">
          <span class="font_3">全国有&nbsp;&nbsp;195&nbsp;&nbsp;个站点</span>
          <!-- <span class="font_3">已覆盖全国</span> -->
          <!-- <span class="text_11">194</span> -->
          <!-- <span class="font_3">省市</span> -->
        </div>
        <img
          class="image_2"
          src="@/assets/images/map1230.jpg"
        />
      </div>
    </div>
    <div class="quick-flex-col quick-items-start group_4 space-y-36" style="overflow:visible">
        <div class="group_5">
          <span class="font_3" style="line-height:0.14rem;">全国业务联系方式</span>
        </div>
      </div>
    <div style="display: flex; flex-direction: column">
      <img
        :src="url.url"
        :id="url.id"
        v-for="url in tableData"
        :key="url.id"
        alt=""
        class="c-imgs"
      />
    </div>
    <!-- <img class="message" src="../assets/message.jpg" alt="" /> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      navActive: 0,
      tableData: [
        {
          id: 1,
          name: "东北区",
          url:  require('@/assets/images/dbq1119.jpg'),
        },
        {
          id: 2,
          name: "华东区",
          url:  require('@/assets/images/hdq1009.jpg'),
        },
        {
          id: 3,
          name: "华北区",
          url: require('@/assets/images/hbq1009.jpg'),
        },
        {
          id: 4,
          name: "华中区",
          url: require('@/assets/images/hzq1118.jpg'),
        },
        {
          id: 5,
          name: "华南区",
          url: require('@/assets/images/hnq1230.jpg'),
        },
        {
          id: 6,
          name: "西南区",
          url:  require('@/assets/images/xnq1009.jpg'),
        },
        {
          id: 7,
          name: "中南区",
          url: require('@/assets/images/znq1009.jpg'),
        },
        {
          id: 8,
          name: "西北区",
          url:  require('@/assets/images/xbq1009.jpg'),
        },
        {
          id: 9,
          name: "新疆",
          url: require('@/assets/images/xj1230.jpg'),
        },
        {
          id: 10,
          name: "西藏",
          url: "https://official-1317286948.cos.ap-beijing.myqcloud.com/%E7%94%BB%E6%9D%BF%2021.jpg",
        },
      ],
    };
  },
  methods: {
    getId(i) {
      return `#${i}`;
    },
  },
};
</script> 

<style scoped>
/************************************************************
** 请将全局样式拷贝到项目的全局 CSS 文件或者当前页面的顶部 **
** 否则页面将无法正常显示                                  **
************************************************************/

html {
  font-size: 256px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    "Microsoft Yahei", sans-serif;
}

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}

#app {
  width: 100vw;
  height: 100vh;
}

.quick-flex-row {
  display: flex;
  flex-direction: row;
}

.quick-flex-col {
  display: flex;
  flex-direction: column;
}

.quick-justify-start {
  justify-content: flex-start;
}

.quick-justify-end {
  justify-content: flex-end;
}

.quick-justify-center {
  justify-content: center;
}

.quick-justify-between {
  justify-content: space-between;
}

.quick-justify-around {
  justify-content: space-around;
}

.quick-justify-evenly {
  justify-content: space-evenly;
}

.quick-items-start {
  align-items: flex-start;
}

.quick-items-end {
  align-items: flex-end;
}

.quick-items-center {
  align-items: center;
}

.quick-items-baseline {
  align-items: baseline;
}

.quick-items-stretch {
  align-items: stretch;
}

.quick-self-start {
  align-self: flex-start;
}

.quick-self-end {
  align-self: flex-end;
}

.quick-self-center {
  align-self: center;
}

.quick-self-baseline {
  align-self: baseline;
}

.quick-self-stretch {
  align-self: stretch;
}

.quick-flex-1 {
  flex: 1 1 0%;
}

.quick-flex-auto {
  flex: 1 1 auto;
}

.quick-grow {
  flex-grow: 1;
}

.quick-grow-0 {
  flex-grow: 0;
}

.quick-shrink {
  flex-shrink: 1;
}

.quick-shrink-0 {
  flex-shrink: 0;
}

.quick-relative {
  position: relative;
}
.section_2 {
  padding: 0.67rem 1.25rem 0.84rem;
  background-image:url("https://official-1317286948.cos.ap-beijing.myqcloud.com/nav3.webp"), url("https://official-1317286948.cos.ap-beijing.myqcloud.com/home-head-8.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 2.09rem;
}
.space-y-68 > *:not(:first-child) {
  margin-top: 0.27rem;
}
.text_9 {
  color: #ffffff;
  font-size: 0.23rem;
  font-family: PingFang;
  font-weight: 700;
  line-height: 0.22rem;
}
.text_10 {
  color: #ffffff;
  font-size: 0.1rem;
  font-family: PingFang;
  line-height: 0.1rem;
}

.group_4 {
  margin-top: 0.2rem;
  padding: 0 1.23rem;
}
.space-y-36 > *:not(:first-child) {
  margin-top: 0.14rem;
}
.group_5 {
  margin-left: 0.039rem;
  line-height: 0.14rem;
}
.font_3 {
  font-size: 0.14rem;
  font-family: SourceHanSansCN;
  line-height: 0.13rem;
  color: #000000;
}
.text_11 {
  color: #000000;
  font-size: 0.19rem;
  font-family: SourceHanSansCN;
  line-height: 0.14rem;
}
.image_2 {
  width: 5.05rem;
  height: 4.41rem;
}
.message {
  width: 100%;
}
.nav {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(245, 245, 245, 1);
  font-size: 0.07rem;
  height: 0.2rem;
}
.nav-box {
  padding: 0 0.1rem;
  cursor: pointer;
}

.nav-box:hover {
  color: #3c9cff !important;
}

.nav-box ~ .nav-box {
  border-left: 0.004rem solid rgba(128, 128, 128, 1);
}

a {
  text-decoration: none; /* 去除默认的下划线 */
  color: inherit; /* 去除默认的颜色和点击后变化的颜色 */
}

.c-imgs {
  /* padding-top: 0.32rem; */
}
</style>



// WEBPACK FOOTER //
// src/views/quick.vue